// @ts-nocheck
// TODO: tighten types after migration
import React, { useEffect, useMemo, useState } from "react";
import "./Images.css";

export default function Images({ images = [] }) {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [failedImages, setFailedImages] = useState([]);
    
    const allImages = useMemo(() => images
        .map(img => {
            if (typeof img === 'string') {
                const trimmed = img.trim();
                return trimmed ? { url: trimmed, altText: '' } : null;
            }

            if (img && typeof img === 'object' && typeof img.url === 'string' && img.url.trim()) {
                return {
                    url: img.url.trim(),
                    altText: img.altText || img.alt || img.title || ''
                };
            }

            return null;
        })
        .filter(Boolean), [images]);

    const availableImages = useMemo(() => allImages.filter(image => !failedImages.includes(image.url)), [allImages, failedImages]);
    const safeCurrentImage = availableImages[currentImageIndex] || availableImages[0] || null;

    useEffect(() => {
        setCurrentImageIndex(0);
        setFailedImages([]);
    }, [images]);

    useEffect(() => {
        if (currentImageIndex >= availableImages.length && availableImages.length > 0) {
            setCurrentImageIndex(0);
        }
    }, [availableImages.length, currentImageIndex]);

    if (!safeCurrentImage) {
        return (
            <div className="image-area relative flex w-full flex-col gap-[1rem] overflow-hidden rounded-[10px] bg-white">
                <div className="no-image flex min-h-[320px] w-full items-center justify-center rounded-[14px] border border-[#dee2e6] bg-[#f8f9fa] text-[1.2rem] text-[#6c757d] box-border">No Image Available</div>
            </div>
        );
    }

    const handleThumbnailClick = (index) => {
        setCurrentImageIndex(index);
    };

    return (
        <div className="image-area relative flex w-full flex-col gap-[1rem] overflow-hidden rounded-[10px] bg-white">
            <div className="main-image-container relative flex w-full min-h-[320px] items-center justify-center overflow-hidden rounded-[14px] border border-[#e5e7eb] bg-[linear-gradient(180deg,#fbfbfd_0%,#f3f5f8_100%)] [aspect-ratio:1/1] max-[480px]:min-h-[260px] min-[481px]:max-[767px]:min-h-[300px]">
                <img
                    className="image-view mx-auto block h-full w-full object-contain p-[1rem] box-border transition-transform duration-300 ease-in-out max-[480px]:p-[0.75rem] min-[481px]:max-[767px]:p-[0.875rem]"
                    src={safeCurrentImage.url}
                    alt={safeCurrentImage.altText || `Product ${currentImageIndex + 1}`}
                    decoding="async"
                    onError={() => {
                        const failedUrl = safeCurrentImage.url;
                        setFailedImages(prev => prev.includes(failedUrl) ? prev : [...prev, failedUrl]);
                    }}
                />
            </div>

            {/* Thumbnail gallery */}
            {availableImages.length > 1 && (
                <div className="thumbnail-gallery flex gap-[10px] overflow-x-auto bg-transparent p-[4px] max-[480px]:gap-[8px] max-[480px]:p-[2px]">
                    {availableImages.map((image, index) => (
                        <img
                            key={image.url}
                            src={image.url}
                            alt={image.altText || `Thumbnail ${index + 1}`}
                            className={`thumbnail h-[88px] w-[88px] min-w-[88px] max-w-[88px] shrink-0 cursor-pointer rounded-[12px] border bg-white object-cover transition-all duration-300 ease-in-out max-[480px]:h-[72px] max-[480px]:w-[72px] max-[480px]:min-w-[72px] max-[480px]:max-w-[72px] min-[481px]:max-[767px]:h-[78px] min-[481px]:max-[767px]:w-[78px] min-[481px]:max-[767px]:min-w-[78px] min-[481px]:max-[767px]:max-w-[78px] min-[768px]:max-[1024px]:h-[96px] min-[768px]:max-[1024px]:w-[96px] min-[768px]:max-[1024px]:min-w-[96px] min-[768px]:max-[1024px]:max-w-[96px] ${index === currentImageIndex ? 'active border-[2px] border-[#47b5ff] shadow-[0_0_0_3px_rgba(71,181,255,0.15)]' : 'border-[#d1d5db] hover:scale-[1.05] hover:border-slider'}`}
                            onClick={() => handleThumbnailClick(index)}
                            loading="lazy"
                            decoding="async"
                            onError={() => {
                                setFailedImages(prev => prev.includes(image.url) ? prev : [...prev, image.url]);
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}
